import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

export default class Heading extends React.Component
{
    static propTypes = {
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        actions: PropTypes.any,
    };

    static defaultProps = {
        actions: null,
        description: ''
    };

    render()
    {
        return <div className="space-y-4">
            <div className="flex items-center justify-between space-x-4 h-10">
                <h2 className="text-2xl leading-6 text-gray-900">
                    { this.props.title }
                </h2>
                <div className="flex space-x-3">
                    { this.props.actions }
                </div>
            </div>
            <p className='text-gray-400'>
                { this.props.description }
            </p>
        </div>;
    }
}

